
/**
 * WebSocket API Configuration
 * 
 * This service provides a centralized way to create WebSocket connections,
 * mirroring the pattern used in baseapi.ts for REST endpoints.
 */

const gocreateSocket = (endpoint: string) => {
  const token = localStorage.getItem('access_token');
  const teamscheck = localStorage.getItem('inTeams') === 'true';
  const customDomain = localStorage.getItem('custom_domain');

  let host = window.location.host;
  if (teamscheck && customDomain) {
    host = customDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }

  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const wsBaseURL = `${wsProtocol}//${host}/ws/`;

  // Construct the full URL relative to our API base
  // URL constructor handles path joining correctly if baseURL ends with /
  const url = new URL(endpoint, wsBaseURL);

  // Since browser WebSocket API doesn't support custom headers,
  // we attach the access token as a query parameter.
  if (token) {
    url.searchParams.append('token', token);
  }

  return new WebSocket(url.toString());
};

export default gocreateSocket;
